var $ = require("jquery");

$(function(){
  var cssRec = {'background': '#fdf6f4'};
  var cssSuccess = {'background':'#d0e8c7'};
  var cssFocus = {'background':'#fff6c8'};
  var cssDef = {'background':'#eee'};
  var $formEle;
  $formEle = void 0;
  $formEle = $('input[type=text],input[type=email], select, textarea');

  // load後
  $formEle.each(function() {
    var b;
    b = void 0;
    b = $(this).val();
    if(b === '' || b === '--都道府県--') {
      var c = $(this).parent().attr('class');
      var cc = $(this).parent().parent().attr('class');
      if(c === 'f-required' || cc === 'f-required') {
        $(this).css(cssRec);
      } else {
        $(this).css(cssDef);
      }
    } else if(b === '--都道府県--') {
      $(this).css(cssRec);
    } else {
      $(this).css(cssSuccess);
    }
  });

  // フォーカスから外れた後の処理
  $formEle.on('blur', function(){
    if($(this).val() === '' || $(this).val() === '--都道府県--') {
      var c = $(this).parent().attr('class');
      var cc = $(this).parent().parent().attr('class');
      if(c === 'f-required' || cc === 'f-required') {
        $(this).css(cssRec);
      } else {
        $(this).css(cssDef);
      }
    } else {
      $(this).css(cssSuccess);
    }
  });

  $formEle.on('focus', function(){
    $(this).css(cssFocus);
  });

  // カレンダー入力後 valueがnullが空判定になるので
  setInterval(function(){
    var date = $('input[name=date]').val();
    if( date === '') {
      return;
    } else {
      $('input[name=date]').css(cssSuccess);
    }
  },50);

});

// 郵便番号入力
$(function() {
  $('input[name="zip1"]').keyup(function() {
    AjaxZip3.zip2addr('zip1', 'zip2', 'address1', 'address2');
  });
});
